module.exports = __webpack_public_path__ + "static/media/flag-lo.76ccf3c4.webp";